import { render, staticRenderFns } from "./showCompanies.vue?vue&type=template&id=487d2e66"
import script from "./showCompanies.vue?vue&type=script&lang=js"
export * from "./showCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports